import apiClient from '../config/axiosConfig'; // eslint-disable-line
import { setToken } from './setToken';

export const refreshToken = () => {
    apiClient({
        url: '/v3/token/refresh',
        
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${window.genesisToken()}`
        },
        skipAuth: true, // Skip automatic auth for token refresh
    })
        .then((response) => {
            localStorage.setItem('AuthToken', response.data.data.token);
            sessionStorage.setItem('SessionId', response.data.data.sessionId);
            setToken();
        })
        .catch(() => {
            // throw error?
        });
};

export function createsession() {
    const jwt = window.genesisToken();
    apiClient({
        url: '/v3/unity/createsession',
        params: {
            jwt
        },
        method: 'POST',
        skipAuth: true, // Skip automatic auth for session creation
    })
        .then((response) => {
            console.log('saving session');
            localStorage.setItem('SessionId', response.data.Data.data.session.id);
            sessionStorage.setItem('SessionId', response.data.Data.data.session.id);
            localStorage.setItem('AuthToken', jwt);
            console.log('About to set the unity orgid');
            localStorage.setItem('UnityOrgId', response.data.Data.data.user.current_organization.id);
            localStorage.setItem('ChurchName', response.data.Data.data.user.current_organization.name);
            localStorage.setItem('ChurchLogo', response.data.Data.data.user.current_organization.logo_url);
            localStorage.setItem('AllData', response.data.Data.data.user.current_organization);
            /* following local storage set items is for pendo in appbuilderHeader file */
            localStorage.setItem('UnityUserId', response.data.Data.data.user.id);
            localStorage.setItem('UnityEmail', response.data.Data.data.user.email);
            localStorage.setItem('FirstName', response.data.Data.data.user.first_name);
            localStorage.setItem('LastName', response.data.Data.data.user.last_name);
            /*******************/
            let givingAdminModule = 'unknown';
            let givingDarkProvision = 'unknown';
            localStorage.setItem('HasGiving', 'false');
            let appBuilderModuleName = 'unknown';
            let trial = 'unknown';
            let modulesLength = response.data.Data.data.user.current_organization.modules.length;
            for (let i = 0; i < modulesLength; i++) {
                givingAdminModule = response.data.Data.data.user.current_organization.modules[i].name;
                if(givingAdminModule === 'Giving Admin') {
                    givingDarkProvision = response.data.Data.data.user.current_organization.modules[i].is_dark_provisioned.toString();
                    if(givingDarkProvision === 'false' ){
                    localStorage.setItem('HasGiving', response.data.Data.data.user.current_organization.modules[i].active);
                    }
                }
            }
            localStorage.setItem('ChurchLogo', response.data.Data.data.user.current_organization.logo_url);
            let ModulesData = JSON.stringify(response.data.Data.data.user.current_organization.modules);
            localStorage.setItem('ModulesData', ModulesData);

            for (let i = 0; i < modulesLength; i++) {
                appBuilderModuleName = response.data.Data.data.user.current_organization.modules[i].name.toString();
                if (['Mobile App', 'App Builder'].includes(appBuilderModuleName)) {
                    trial = response.data.Data.data.user.current_organization.modules[i].current_status.toString();
                    if (trial === 'Trialing'){
                        localStorage.setItem('IsTrial', 'true');
                    }
                }
            }
        })
        .catch((error) => {
            localStorage.clear();
            console.log(error);
            window.location = error.response.data.Message;
        });
}

export default refreshToken;
